export default "__VITE_ASSET__99369ced__"